import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function SevakCardsSlider({ data, logo }) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const sevaks =data


  return (
    <section className="py-16  overflow-hidden relative">
      {/* Navigation Buttons */}
      <button
        ref={prevRef}
        className="
            absolute left-2 top-1/2 z-10 -translate-y-1/2
            h-9 w-9 flex items-center justify-center
            rounded-full bg-white shadow-md
            border border-orange-200
            text-orange-700
            hover:bg-orange-50
            transition
          "
      >
        <ChevronLeft size={18} />
      </button>

      <button
        ref={nextRef}
        className="
            absolute right-2 top-1/2 z-10 -translate-y-1/2
            h-9 w-9 flex items-center justify-center
            rounded-full bg-white shadow-md
            border border-orange-200
            text-orange-700
            hover:bg-orange-50
            transition
          "
      >
        <ChevronRight size={18} />
      </button>
      <Swiper
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        modules={[Navigation, Autoplay]}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        loop={sevaks?.length > 1}
        spaceBetween={14}
        // slidesPerView={3}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {sevaks?.map((user) => (
          <SwiperSlide key={user?.id}>
            <div className="relative group">
              {/* Card Border */}
              <div className="relative p-[3px] border-[30px] border-r-[#f07c14] border-t-[#f07c14] border-b-[#9b1c3c] border-l-[#9b1c3c]">
                {/* Card */}
                <div className=" overflow-hidden h-full">
                  <div className="text-center">
                    {/* Logo */}

                    <div className="relative w-[110px] h-[50px] mx-auto mb-3  overflow-hidden">
                      <img
                        src={logo}
                        alt={user?.name}
                        className="w-full h-full object-fill"
                      />
                    </div>

                    {/* Profile */}
                    <div className="relative w-[110px] h-[125px] mx-auto mb-4 overflow-hidden border-gray-900 border-[2px] ">
                      <img
                        src={user?.picture}
                        alt={user?.name}
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* Name */}
                    <h3 className="text-[16px] font-black uppercase text-gray-900 leading-tight">
                      {user?.name}
                    </h3>

                    {/* Designation */}
                    <div className="mt-2 inline-flex   text-red-700 text-sm font-semibold ">
                      {user?.designation}
                    </div>

                    {/* Info */}
                    <div className="mt-3 space-y-6 text-left">
                      <div>
                        <div className="flex items-start justify-center gap-1 text-[16px]">
                          <span>ID:</span>

                          <span>{user?.sevak_id}</span>
                        </div>

                        <div className="flex items-start justify-center gap-1 text-[16px]">
                          <span>Valid Till</span>

                          <span>{user?.valid_till}</span>
                        </div>
                      </div>

                      <div className="text-[16px] flex flex-col items-center">
                        <div>{user?.telephone}</div>

                        <div className="text-[16px]">{user?.email}</div>
                        <div className="text-[16px]">
                          Blood Group - {user?.blood_group}
                        </div>
                      </div>
                    </div>

                    {/* QR */}
                    <div className="mt-2 flex justify-center">
                      <img
                        src={`https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${user?.qr_url}`}
                        alt="QR"
                        className="w-[95px] h-[95px]"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
